import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';

import { ModalSize } from '@d-constants';
import { ModalService } from '@d-services';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-base-modal-shell',
  templateUrl: './modal-shell.component.html',
  styleUrls: ['./modal-shell.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class ModalShellComponent implements OnInit {
  title = '';
  titleKey = '';
  titleParam = {} as object;
  size: ModalSize = ModalSize.SMALL;
  confirmMessage = '';
  showIconClose = true;

  @ViewChild('dialogContainer', { static: true, read: ViewContainerRef })
  dialogContainer!: ViewContainerRef;
  constructor(private modalService: ModalService) {}

  ngOnInit(): void {
    if (typeof this.modalService.currentComponentRef.component === 'string') {
      this.confirmMessage = this.modalService.currentComponentRef.component;

      this.size =
        this.modalService.currentComponentRef.params.size || ModalSize.SMALL;
    } else {
      this.createContent();
    }

    if (this.modalService.currentComponentRef.params.title) {
      if (
        typeof this.modalService.currentComponentRef.params.title === 'string'
      ) {
        this.titleKey =
          this.modalService.currentComponentRef.params.title || '';
      } else {
        this.titleKey =
          this.modalService.currentComponentRef.params.title.key || '';
        this.titleParam =
          this.modalService.currentComponentRef.params.title.params || {};
      }
    }

    if (
      typeof this.modalService.currentComponentRef.params.showIconClose ===
      'boolean'
    ) {
      this.showIconClose =
        this.modalService.currentComponentRef.params.showIconClose;
    }
  }

  closeDialog(type?: string) {
    this.modalService.closeModal({ actionType: type });
    this.dialogContainer.clear();
  }

  createContent() {
    if (this.dialogContainer) this.dialogContainer.clear();
    const componentRef = this.dialogContainer.createComponent(
      this.modalService.currentComponentRef.component,
    );
    const componentInstance = componentRef.instance as any;

    if (this.modalService.currentComponentRef.params) {
      this.title = this.modalService.currentComponentRef.params.title || '';
      this.size =
        this.modalService.currentComponentRef.params.size || ModalSize.SMALL;
      Object.keys(this.modalService.currentComponentRef.params).forEach(
        (propertyName) => {
          componentInstance[propertyName] =
            this.modalService.currentComponentRef.params[propertyName];
        },
      );
    }
  }
}
